import gql from 'graphql-tag';

export const GET_STAGE_ATTRIBUTE_DOCUMENTS = gql`
  query GetStageAttributeDocuments($input: StageAttributeDocumentsInput!) {
    bpf {
      result: stageAttributeDocuments(input: $input) {
        error
        success
        list {
          id
          attributeId
          availableForRoles
          documents {
            id
            source
            docName
            createdDateTime
            createdBy {
              id
              fullName
            }
          }
        }
      }
    }
  }
`;
